"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurgeryEventRecording_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var SurgeryEventRecording_Factory = /** @class */ (function () {
    function SurgeryEventRecording_Factory() {
    }
    SurgeryEventRecording_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            EventTypeCode: model.EventTypeCode,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    SurgeryEventRecording_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            EventTypeCode: model.EventTypeCode,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    return SurgeryEventRecording_Factory;
}());
exports.SurgeryEventRecording_Factory = SurgeryEventRecording_Factory;
